// extracted by mini-css-extract-plugin
module.exports = {"products":"AutocompleteProducts_products__vl-DH","seeAllButtonWrapper":"AutocompleteProducts_seeAllButtonWrapper__1Fygz","seeAllButton":"AutocompleteProducts_seeAllButton__11oNH"};